export default {
  api: {
    emailAddress: {
      email: {
        notNull: "Voer een E-mailadres in",
        invalid: "Geen geldig e-mailadres",
      },
      type: {
        notNull: "Selecteer een type e-mailadres",
        found: "Type e-mailadres bestaat al",
      },
    },
  },
}
